import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDialogRef } from '@angular/material/dialog';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { authHeaderInterceptor, jwtInterceptor } from '@cavo-admin/auth';
import { APP_ROUTES } from './app.routes';

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(APP_ROUTES),
		provideAnimations(),
		provideHttpClient(withInterceptors([jwtInterceptor, authHeaderInterceptor])),
		provideMomentDateAdapter(undefined, { strict: true }),
		{ provide: MatDialogRef, useValue: {} },
	],
};
